<script>
export default {
  name: 'PageLimitSelector',
  components: {
    SelectField: () => import('@/components/general/SelectField')
  },

  props: {
    value: {
      type: Number,
      default: 10
    },

    options: {
      type: Array,
      default () {
        return [
          10,
          20,
          50
        ]
      }
    },

    label: {
      type: String,
      default: 'Itens por página'
    },

    itemSuffix: {
      type: String,
      default: 'itens'
    },

    storageKey: {
      type: String,
      default: null
    }
  },

  computed: {
    selectItems () {
      return this.options
        .slice()
        .sort((a, b) => a - b)
        .map(opt => ({
          text: `${opt} ${this.itemSuffix}`,
          value: opt
        }))
    }
  },

  mounted () {
    let preferredValue = null

    if (this.storageKey) {
      try {
        const stored = window.localStorage.getItem(this.storageKey)

        if (stored !== null) {
          const parsed = Number(stored)

          if (Number.isFinite(parsed) && this.options.includes(parsed)) {
            preferredValue = parsed
          }
        }
      } catch (e) {
        // localStorage indisponível (modo privado, quota); silencioso.
      }
    }

    if (preferredValue === null && !this.options.includes(this.value)) {
      preferredValue = this.findClosestOption(this.value)
    }

    if (preferredValue !== null && preferredValue !== this.value) {
      this.persist(preferredValue)
      this.$emit('input', preferredValue)
    }
  },

  methods: {
    onChange (newValue) {
      if (newValue === null || newValue === undefined) return
      if (newValue === this.value) return

      this.persist(newValue)
      this.$emit('input', newValue)
    },

    findClosestOption (value) {
      if (!this.options.length) return value

      return this.options.reduce((closest, opt) => {
        return Math.abs(opt - value) < Math.abs(closest - value) ? opt : closest
      }, this.options[0])
    },

    persist (newValue) {
      if (!this.storageKey) return

      try {
        window.localStorage.setItem(this.storageKey, String(newValue))
      } catch (e) {
      }
    }
  }
}
</script>

<template>
  <div class="page-limit-selector">
    <SelectField
      :value="value"
      :items="selectItems"
      :label="label"
      :floating-label="false"
      @input="onChange"
    />
  </div>
</template>

<style scoped>
.page-limit-selector {
  display: inline-block;
  vertical-align: top;
  width: 140px;
  margin-right: 12px;
}

.page-limit-selector >>> .form-item {
  margin-bottom: 0;
}

.page-limit-selector >>> .form-label {
  font-size: 1.1em;
  letter-spacing: 0.2px;
  white-space: nowrap;
}

/* Esconde o "x" de limpar — sempre existe um valor selecionado */
.page-limit-selector >>> .form-input-append > a {
  display: none;
}
</style>
